/*
 * MyPopMee — Socle gravé (MAIN storefront)
 * ---------------------------------------------------------------
 * Le socle n'est JAMAIS une propriété de ligne ni une option ajoutée au
 * produit SANS socle : choisir "Avec socle" redirige vers un AUTRE produit
 * (importé via MadeMine, avec socle) sur la variante équivalente. MadeMine
 * lit ?variant= au chargement, donc une vraie navigation est obligatoire.
 *
 * Trois familles : premium (1 person), couple (2 people connected) et pet
 * (1 pet). Couple et pet partagent le même produit source : la famille est
 * choisie d'après le Style de la variante source réellement sélectionnée,
 * jamais d'après le seul ID produit.
 *
 * Fail-closed : sans configuration vérifiée (snippets/pm-socle.liquid),
 * sans produit "avec socle" résolu, ou sans variante unique correspondante,
 * aucun lien n'est proposé. Aucun ID de variante n'est codé en dur : tout
 * est résolu à partir des variantes réelles rendues par Shopify.
 *
 * Fonctions pures exportées pour la QA locale (Node), voir .qa-socle-pet/.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    // Script inclus à la fois par la fiche produit et par la garde panier :
    // une seule initialisation.
    if (root.PmSocle) return;
    root.PmSocle = api;
    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { api.boot(document); }, { once: true });
      } else {
        api.boot(document);
      }
    }
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Produits sur lesquels un socle n'est jamais proposé (porte-clés).
  var KEYCHAIN_PRODUCT_IDS = ['16071625802062'];

  // Taille d'une valeur d'option MadeMine : "6CM=2.36inch", "6 cm", "6CM" -> "6".
  function sizeKey(value) {
    var m = /^\s*(\d+)\s*cm\b/i.exec(String(value == null ? '' : value));
    return m ? m[1] : null;
  }

  // Disposition Couple : "2 people (Connected)" -> "connected".
  function layoutKind(value) {
    var v = String(value == null ? '' : value).toLowerCase();
    if (/\bunconnected\b|s[ée]par[ée]e?s?/.test(v)) return 'unconnected';
    if (/\bconnected\b|attach[ée]e?s?/.test(v)) return 'connected';
    return null;
  }

  function optionNames(product) {
    return (product && product.options || []).map(function (o) {
      return String(typeof o === 'string' ? o : (o && o.name) || '').trim().toLowerCase();
    });
  }

  // Index de l'option Taille (détectée par valeur, pas par intitulé : les
  // imports MadeMine nomment l'option "Size" ou "Taille").
  function sizeIndex(product) {
    var variants = product && product.variants || [];
    var count = optionNames(product).length;
    for (var i = 0; i < count; i++) {
      if (variants.some(function (v) { return sizeKey(v.options[i]) !== null; })) return i;
    }
    return -1;
  }

  function layoutIndex(product) {
    var variants = product && product.variants || [];
    var count = optionNames(product).length;
    for (var i = 0; i < count; i++) {
      if (variants.some(function (v) { return layoutKind(v.options[i]) !== null; })) return i;
    }
    return -1;
  }

  function styleKey(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[\s_-]/g, '');
  }

  function styleIndex(product) {
    var names = optionNames(product), idx = names.indexOf('style');
    if (idx < 0) idx = names.indexOf('type');
    if (idx < 0) {
      for (var i = 0; i < names.length; i++) {
        if ((product.variants || []).some(function (v) { return /^1\s*(person|pet|animal)|^2\s*people/i.test(String(v.options[i] || '')); })) return i;
      }
    }
    return idx;
  }

  function allowedSizes(family) {
    return String(family && family.sizes || '').split(',').map(function (v) { return v.trim(); }).filter(Boolean);
  }

  function isFamilyEnabled(family, sourceProduct, withBaseProduct) {
    if (!family || family.verified !== true || !family.style || !family.with_base_handle || !sourceProduct || !withBaseProduct) return false;
    if (String(sourceProduct.id) === String(withBaseProduct.id)) return false;
    if (KEYCHAIN_PRODUCT_IDS.indexOf(String(sourceProduct.id)) !== -1 || KEYCHAIN_PRODUCT_IDS.indexOf(String(withBaseProduct.id)) !== -1) return false;
    return sizeIndex(withBaseProduct) >= 0 && styleIndex(withBaseProduct) >= 0 && allowedSizes(family).length > 0;
  }

  function allowedWithBaseVariants(family, withBaseProduct) {
    var sidx = sizeIndex(withBaseProduct), tidx = styleIndex(withBaseProduct);
    if (sidx < 0 || tidx < 0 || !family || !family.style) return [];
    var sizes = allowedSizes(family), kind = styleKey(family.style);
    return (withBaseProduct.variants || []).filter(function (v) {
      return sizes.indexOf(sizeKey(v.options[sidx])) >= 0 && styleKey(v.options[tidx]) === kind;
    });
  }

  // La variante source appartient-elle à la famille ? Une famille avec
  // source_styles exige le Style exact (couple attaché / 1 animal) ; sans
  // source_styles (premium), la source ne doit pas avoir d'option Style.
  function sourceVariantMatchesFamily(family, sourceProduct, sourceVariant) {
    if (!family || !sourceProduct || !sourceVariant) return false;
    // MYPOPMEE_SOCLE_IDS_20261030 : IDs Shopify des variantes source (identiques dans toutes les langues), prioritaires sur le libellé.
    if (family.source_variant_ids && family.source_variant_ids.length) {
      return family.source_variant_ids.map(String).indexOf(String(sourceVariant.id)) !== -1;
    }
    var skidx = styleIndex(sourceProduct);
    if (family.source_styles) {
      return skidx >= 0 && styleKey(sourceVariant.options[skidx]) === styleKey(family.source_styles);
    }
    return skidx < 0;
  }

  function resolveWithBaseVariant(family, sourceProduct, sourceVariant, withBaseProduct) {
    if (!isFamilyEnabled(family, sourceProduct, withBaseProduct) || !sourceVariant) return null;
    var ssidx = sizeIndex(sourceProduct);
    if (ssidx < 0) return null;
    if (family.source_styles && !sourceVariantMatchesFamily(family, sourceProduct, sourceVariant)) return null;
    var size = sizeKey(sourceVariant.options[ssidx]), tidx = sizeIndex(withBaseProduct);
    if (!size || allowedSizes(family).indexOf(size) === -1) return null;
    var pool = allowedWithBaseVariants(family, withBaseProduct).filter(function (v) {
      return sizeKey(v.options[tidx]) === size && v.available;
    });
    return pool.length === 1 ? pool[0] : null;
  }

  // Fiche source : famille correspondant à la variante RÉELLEMENT sélectionnée
  // (Couple et Animal partagent le même produit). Ambiguïté -> null.
  function familyForSourceVariant(families, variantId) {
    var matches = (families || []).filter(function (f) {
      var src = f && f.source_product;
      return src && sourceVariantMatchesFamily(f, src, findById(src, variantId));
    });
    return matches.length === 1 ? matches[0] : null;
  }

  // Fiche avec socle : famille d'après le Style exact de la variante avec socle.
  function familyForWithBaseVariant(families, withBaseProduct, withBaseVariant) {
    var kindIdx = styleIndex(withBaseProduct);
    if (!withBaseVariant || kindIdx < 0) return null;
    var key = styleKey(withBaseVariant.options[kindIdx]);
    var matches = (families || []).filter(function (f) { return f && styleKey(f.style) === key; });
    return matches.length === 1 ? matches[0] : null;
  }

  function resolveSourceVariant(family, withBaseProduct, withBaseVariant, sourceProduct, visibleSourceIds) {
    if (!sourceProduct || !withBaseVariant) return null;
    var size = sizeKey(withBaseVariant.options[sizeIndex(withBaseProduct)]);
    var srcSizeIdx = sizeIndex(sourceProduct);
    if (!size || srcSizeIdx === -1) return null;
    var ids = (visibleSourceIds || []).map(String);
    var pool = (sourceProduct.variants || []).filter(function (v) {
      return (!ids.length || ids.indexOf(String(v.id)) !== -1) && sizeKey(v.options[srcSizeIdx]) === size;
    });
    // Le retour sans socle reste sur le Style source exact de la famille :
    // couple -> "attachées" (jamais séparées, même en 4 cm), animal -> "1 animal".
    if (family && family.source_variant_ids && family.source_variant_ids.length) {
      var srcIds = family.source_variant_ids.map(String);
      pool = pool.filter(function (v) { return srcIds.indexOf(String(v.id)) !== -1; });
    } else if (family && family.source_styles) {
      var srcStyleIdx = styleIndex(sourceProduct);
      if (srcStyleIdx === -1) return null;
      pool = pool.filter(function (v) {
        return styleKey(v.options[srcStyleIdx]) === styleKey(family.source_styles);
      });
    }
    if (pool.length !== 1 && family && family.source_styles) return null;
    return pool.length ? pool[0] : null;
  }

  function variantUrl(product, variant) {
    if (!product || !product.url || !variant) return null;
    return product.url.split('?')[0] + '?variant=' + encodeURIComponent(variant.id);
  }

  // --- Garde panier ------------------------------------------------------
  var SOCLE_PROPERTY_RE = /socle|gravure|engrav|with[\s_-]*base|avec[\s_-]*socle/i;

  // Lignes interdites : un produit SANS socle (ou un porte-clés) portant une
  // propriété "socle"/"gravure". Le socle ne doit exister que sous forme du
  // produit MadeMine "avec socle" distinct.
  function findInvalidSocleLines(cart, guardedProductIds) {
    var ids = (guardedProductIds || []).map(String).concat(KEYCHAIN_PRODUCT_IDS);
    return (cart && cart.items || []).filter(function (item) {
      if (ids.indexOf(String(item.product_id)) === -1) return false;
      var props = item.properties || {};
      return Object.keys(props).some(function (k) {
        var val = props[k];
        if (val === null || val === undefined || val === '') return false;
        return SOCLE_PROPERTY_RE.test(k) || SOCLE_PROPERTY_RE.test(String(val));
      });
    });
  }

  // Lignes du produit AVEC socle tant que l'achat n'est pas validé (prix €
  // non arrêtés) : paiement bloqué. Sans ID produit configuré : rien.
  function findUnpurchasableWithBaseLines(cart, guard) {
    if (!guard || !guard.with_base_product_id || guard.with_base_checkout_allowed === true) return [];
    return (cart && cart.items || []).filter(function (item) {
      return String(item.product_id) === String(guard.with_base_product_id);
    });
  }

  function checkoutProblems(cart, guard) {
    return {
      invalid: findInvalidSocleLines(cart, guard && guard.guarded_product_ids),
      unpurchasable: findUnpurchasableWithBaseLines(cart, guard)
    };
  }

  // --- DOM ---------------------------------------------------------------
  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: currency || 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function readJson(doc, id) {
    var el = doc.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function currentVariantId(doc, data) {
    try {
      var p = new URL(doc.defaultView.location.href).searchParams.get('variant');
      if (p) return p;
    } catch (e) { /* ignore */ }
    return data.current_variant_id ? String(data.current_variant_id) : null;
  }

  function findById(product, id) {
    return (product && product.variants || []).find(function (v) { return String(v.id) === String(id); }) || null;
  }

  function enableLink(el, href) {
    el.setAttribute('href', href);
    el.removeAttribute('aria-disabled');
    el.classList.remove('pp-socle-pill--unavailable');
  }

  function disableLink(el) {
    if (!el) return;
    el.removeAttribute('href');
    el.setAttribute('aria-disabled', 'true');
    el.classList.add('pp-socle-pill--unavailable');
  }

  function familyNote(family) {
    return family && family.name === 'couple' ? 'Avec socle, les deux figurines sont toujours attachées' : '';
  }

  function bootUi(doc, data) {
    var group = doc.getElementById('ppSocleGroup');
    if (!group || !data) return;
    var wb = data.with_base_product, id = currentVariantId(doc, data), note = doc.getElementById('ppSocleNote');
    var families = data.families || (data.family ? [Object.assign({}, data.family, { source_product: data.source_product, source_url: data.source_url, source_visible_ids: data.source_visible_ids })] : []);
    var family = null, src = null;
    group.hidden = true;
    if (note) note.textContent = '';
    if (wb && data.with_base_url) wb.url = data.with_base_url;
    if (data.role === 'source') {
      var link = group.querySelector('[data-socle-choice="with"]');
      disableLink(link);
      family = familyForSourceVariant(families, id);
      if (!family) return;
      src = family.source_product;
      if (family.source_url) src.url = family.source_url;
      var sv = findById(src, id);
      var target = resolveWithBaseVariant(family, src, sv, wb);
      if (!link || !target) return;
      enableLink(link, variantUrl(wb, target));
      var priceEl = link.querySelector('.pp-socle-price');
      // Prix € du produit avec socle non arrêtés : aucun écart affiché.
      if (priceEl) priceEl.textContent = (data.prices_validated === true && sv && target.price > sv.price) ? '+' + money(target.price - sv.price, data.currency) : '';
      if (note) note.textContent = familyNote(family);
      group.hidden = false;
    } else if (data.role === 'with_base') {
      var back = group.querySelector('[data-socle-choice="without"]');
      disableLink(back);
      var bv = findById(wb, id);
      family = familyForWithBaseVariant(families, wb, bv);
      if (!family || !family.source_product) return;
      src = family.source_product;
      if (family.source_url) src.url = family.source_url;
      var candidate = resolveSourceVariant(family, wb, bv, src, family.source_visible_ids || []);
      if (back && candidate) enableLink(back, variantUrl(src, candidate));
      if (note) note.textContent = familyNote(family);
      group.hidden = false;
    }
  }

  function bootCartGuard(doc) {
    var guard = readJson(doc, 'pmSocleGuardData');
    if (!guard) return;
    var win = doc.defaultView;
    var bypass = false;

    function showError(problems) {
      var msgs = [];
      if (problems.invalid.length) {
        msgs.push('Configuration socle invalide dans le panier : retirez « ' +
          problems.invalid.map(function (l) { return l.product_title; }).join(', ') +
          ' » et ajoutez la version « Avec socle » depuis sa fiche produit.');
      }
      if (problems.unpurchasable.length) {
        msgs.push('La version « Avec socle gravé » n\'est pas encore disponible à la commande : retirez « ' +
          problems.unpurchasable.map(function (l) { return l.product_title; }).join(', ') +
          ' » du panier.');
      }
      win.alert(msgs.join('\n\n'));
    }

    function check(proceed) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;
      win.fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var problems = checkoutProblems(cart, guard);
          if (problems.invalid.length || problems.unpurchasable.length) { showError(problems); return false; }
          return true;
        }, function () {
          // Réseau indisponible : la garde est un filet de sécurité secondaire,
          // on ne bloque pas le paiement de toute la boutique pour autant (le
          // produit avec socle reste DRAFT, donc non ajoutable, tant qu'il
          // n'est pas validé).
          return true;
        })
        .then(function (ok) {
          if (timer) clearTimeout(timer);
          if (!ok) return;
          bypass = true;
          try { proceed(); } finally { bypass = false; }
        });
    }

    doc.addEventListener('click', function (e) {
      if (bypass) return;
      var el = e.target && e.target.closest && e.target.closest('[name="checkout"], #mpcCheckoutBtn, a[href*="/checkout"]');
      if (!el) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      check(function () { el.click(); });
    }, true);

    // Soumission clavier (Entrée) d'un formulaire panier vers le paiement.
    doc.addEventListener('submit', function (e) {
      if (bypass) return;
      var form = e.target;
      var submitter = e.submitter;
      var toCheckout = (submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout') ||
        (form && form.getAttribute && /\/checkout/.test(form.getAttribute('action') || ''));
      if (!toCheckout) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      check(function () {
        if (submitter && submitter.click) submitter.click();
        else if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }, true);
  }

  function boot(doc) {
    var data = readJson(doc, 'pmSocleData');
    if (data) {
      var refresh = function () { bootUi(doc, data); };
      refresh();
      doc.addEventListener('click', function (e) {
        var selected = e.target && e.target.closest && e.target.closest('.pp-option-group .pp-pill');
        if (selected && typeof setTimeout === 'function') setTimeout(refresh, 30);
      });
      doc.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.pp-option-group') && typeof setTimeout === 'function') setTimeout(refresh, 30);
      });
    }
    bootCartGuard(doc);
  }

  return {
    KEYCHAIN_PRODUCT_IDS: KEYCHAIN_PRODUCT_IDS,
    sizeKey: sizeKey,
    layoutKind: layoutKind,
    styleKey: styleKey,
    styleIndex: styleIndex,
    sizeIndex: sizeIndex,
    layoutIndex: layoutIndex,
    isFamilyEnabled: isFamilyEnabled,
    allowedWithBaseVariants: allowedWithBaseVariants,
    sourceVariantMatchesFamily: sourceVariantMatchesFamily,
    familyForSourceVariant: familyForSourceVariant,
    familyForWithBaseVariant: familyForWithBaseVariant,
    resolveWithBaseVariant: resolveWithBaseVariant,
    resolveSourceVariant: resolveSourceVariant,
    variantUrl: variantUrl,
    findInvalidSocleLines: findInvalidSocleLines,
    findUnpurchasableWithBaseLines: findUnpurchasableWithBaseLines,
    checkoutProblems: checkoutProblems,
    boot: boot
  };
});
